<template>
    <div class="index"  ref="home">
        <Header :scrollTops="scrollTops"></Header>
        <carousel></carousel>
        <product id="product"></product>
        <serVice></serVice>
        <exhibition ></exhibition>
        <About ></About>
        <Footer ></Footer>
    </div>
</template>

<script>
    //import {isPC,isFireFox} from '../utils/methods'
    import Header from '../pages/header/header'
    import carousel from '../pages/carousel/carousel'
    import exhibition from '../pages/exhibition/exhibition'
    import product from '../pages/productservice/productservice'
    import serVice from '../pages/serviceprogress/serviceprogress'
    import About from '../pages/about/about'
    import Footer from '../pages/footer/footer'
    import {scrollTopsArr,elementShowAddActive,destroyEventListener} from '../utils/lazyActive'
    export default {
        name: 'index',
        components: {
            Header,
            carousel,
            exhibition,
            product,
            serVice,
            About,
            Footer
        },
        data() {
            return {
                currentTouchPosition: 0,
                canIMove: false,
                cloakShow: false,
                scrollTops:{}
            }
        },
        beforeCreate(){
            destroyEventListener()
        },
        mounted() {
            this.scrollTops = scrollTopsArr(this.$children)
            sessionStorage.setItem('offsetTop',JSON.stringify(this.scrollTops))
            elementShowAddActive(this)
        },
        beforeDestroy(){
            destroyEventListener()
        },
        methods: {

        },

    }
</script>

<style scoped lang="scss">
    .block {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 4;
        background-color: white;
    }

    .down-enter-active {
        transition: all .8s ease;
        transform: translateY(0);
    }

    .down-leave-active {
        transition: all .8s ease;
        transform: translateY(-100%);
    }

    .down-enter {
        transform: translateY(100%);
    }

    .down-leave {
        transform: translateY(0);
    }

    .up-enter-active {
        transition: all .8s ease;
        transform: translateY(0);
    }

    .up-leave-active {
        transition: all .8s ease;
        transform: translateY(100%);
    }

    .up-enter {
        transform: translateY(-100%);
    }

    .up-leave {
        transform: translateY(0);
    }

</style>
